module.exports = __webpack_public_path__ + "static/media/hierarquia.fd013e42.png";